import * as angular from "angular";
import {IController} from "angular";

export class fulfillmentItemsListCtrl implements IController {

  items: any;
  stepNumber: any;

  /* @ngInject */
  constructor() {}

  $onInit() {}

}
angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentItemsList', {
    bindings: {
      items: '<',
      stepNumber: '<'
    },
    template: require('./fulfillment-items-list.html').default,
    controller: fulfillmentItemsListCtrl
  });
